export default {
  AgentContracts: {
    createContract: 'New Contract'
  },
  AgencyOverviewStatements: {
    heading: 'Commission statements',
    date: 'Date',
    contractsNumber: 'Number of contracts',
    commissionSum: 'Commission'
  },
  AgenciesList: {
    number: 'Agency number',
    name: 'Agency',
    heading: 'Agency overview',
    commission: 'Commission'
  },
  AgencyCreate: {
    createAgency: 'Create Agency',
    agencyManager: 'Data of agency manager',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'E-Mail',
    agency: 'Data of agency',
    agencyName: 'Agency name',
    agencyNumber: 'Agency number',
    agencyCommission: 'Commission per sale',
    agencyStreet: 'Street',
    close: 'Cancel',
    add: 'Create Agency'
  },
  AgencyEdit: {
    editAgency: 'Save',
    main: 'Base data',
    name: 'Company name',
    number: 'Company Number',
    commission: 'Commission',
    contacts: 'Contact data',
    contact_person: 'Contact person',
    phone: 'Phone',
    mobile_number: 'Mobile',
    city: 'City',
    street: 'Street',
    zip: 'Zip-Code',
    address: 'Address',
    bank: 'Bank data',
    bankname: 'Bank name',
    iban: 'IBAN',
    bic: 'BIC'
  },
  AgencySettings: {
    heading: 'Agency settings',
    agencyEdit: 'Basisdaten',
    agencyContacts: 'Kontaktdaten',
    agencyAddress: 'Adresse',
    agencyCredentials: 'Bankdaten',
    agencyDisable: 'Sperren'
  },
  AgencyOverviewAgentsCreateEntry: {
    heading: 'New agent',
    createEntry: 'Create agent',
    firstName: 'First name',
    lastName: 'Last name',
    cancel: 'Cancel',
    create: 'Create agent',
    number: 'Agent number'
  },
  App: {
    close: 'Close'
  },
  AppLayout: {
    logoutText: 'Logout',
    search: 'Search (Employees, Help, ...)'
  },
  AuthLayout: {
    forgotPassword: 'Forgot password',
    home: 'Homepage',
    login: 'Login'
  },
  CompanyLogEntries: {
    timesheet: {
      create: 'Created a timesheet <a href="{href}">Time sheet</a> (ID: {id})',
      multiple_months_batch: {
        success: 'Created a timesheet {month} for an <a href="{href}">employee</a> (ID: {id})'
      },
      multiple_users_batch: {
        success: 'Created a timesheet {month} for an <a href="{href}">employee</a> (ID: {id})'
      }
    },
    employee: {
      update: 'Updated an <a href="{href}">employee</a>  (ID: {id})',
      delete: 'Deleted an employee (ID: {id})',
      create: 'Created an <a href="{href}">employee</a>  (ID: {id})',
      assigned_as_manager: 'Assigned the role manager to an <a href="{href}">employee</a>  (ID: {id})'
    },
    employee_account: {
      create: 'Created an <a href="{href}">employee account</a>  (ID: {id}) '
    },
    timetracking: {
      start: 'Has started the time tracking',
      stop: 'Has stopped the time tracking'
    },
    activity_period: {
      create: 'Marked <a href="{href}">employee</a>  (ID: {id}) as inactive within the period {period}',
      delete: 'Removed the inactivity period {period} of the <a href="{href}">employee</a>  (ID: {id})'
    },
    salaryGroup: {
      create: 'Has created a new wage group (ID: {id})',
      delete: 'Has updated a wage group (ID: {id})',
      update: 'Has deleted a wage group (ID: {id})'
    }
  },
  CompanyEditor: {
    address: 'Address data',
    basicData: 'Basic data',
    contact: 'Contact data',
    contactPerson: 'Contact person',
    email: 'E-Mail',
    emailNotValid: 'No valid email',
    fax: 'Fax',
    isRequired: 'Required field',
    name: 'Company name',
    phone: 'Phone',
    save: 'Save',
    street: 'Street, House',
    vatNumber: 'Tax Number (USt-ID)'
  },
  CompanyOverview: {
    heading: 'Company overview',
    info: 'General information',
    log: 'Log',
    salary: 'Salary groups'
  },
  CompanySalary: {
    add: 'New salary group',
    cancel: 'Cancel',
    create: 'Create',
    createHeading: 'Create new group',
    deleteAccept: 'Delete',
    deleteBody: 'Only salary groups without assigned employees may be deleted. ',
    deleteHeader: 'Delete salary group?',
    edit: 'Save',
    editHeading: 'Edit salary group',
    heading: 'Salary groups',
    hourlyWage: 'Hourly wage',
    name: 'Name'
  },
  Contract: {
    package: 'Package',
    packageCost: 'Cost per month'
  },
  ContractsTable: {
    heading: 'Contract overview',
    name: 'Company',
    package: 'Package',
    packageCost: 'Package cost per month',
    not_subscribed: 'Inactive contract',
    noInfoYet: 'No data'
  },
  AgencyOverviewAgentsTable: {
    heading: 'Agent overview',
    number: 'Agent number',
    name: 'Name'
  },
  ConfirmModal: {
    cancel: 'Cancel'
  },
  AgencyDisable: {
    headline: 'Disable the agency',
    disableUserWarn: `By blocking the agency, all logins of this agency 
    are blocked, so that no new customers can be recruited. `,
    disableButton: 'Block agency',
    disableHeader: 'Confirm blocking',
    disableBody: 'Do you really want to block this agency?',
    disable: 'Block',
    enable: 'Unblock',
    enableUserWarn: 'By unblocking the agency all logins will be re-enabled.',
    enableHeader: 'Unblock agency',
    enableButton: 'Unblock',
    enableBody: 'Do you really want to unblock this agency? '
  },
  AgentDisable: {
    headline: 'Disable the agent',
    disableButton: 'Block agent',
    disableHeader: 'Confirm blocking',
    disableBody: 'Do you really want to block this agent?',
    disable: 'Block',
    enable: 'Unblock',
    enableHeader: 'Unblock agent',
    enableButton: 'Unblock',
    enableBody: 'Do you really want to unblock this agent? '
  },
  ContractCreate: {
    createCustomer: 'New contract',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    user: 'User data',
    company: 'Company data',
    companyName: 'Company name',
    companyStreet: 'Street, House',
    city: 'City',
    companyPhone: 'Phone',
    add: 'Create'
  },
  DeleteEntry: {
    cancel: 'Cancel',
    delete: 'Delete'
  },
  EmailInput: {
    emailNotValid: 'No valid email',
    emailRequired: 'Required',
    label: 'Email'
  },
  GlobalNotifications: {
    close: 'Close'
  },
  Languages: {
    de: 'German',
    en: 'English'
  },
  Login: {
    heading: 'Login',
    labelPassword: 'Password',
    send: 'send',
    forgotPassword: 'Forgot password'
  },
  MyCompany: {
    heading: 'Firmendaten',
    pleaseFillCompanyData: 'Please fill out all the company data to use the system'
  },
  NotificationBlock: {
    noContent: 'empty'
  },
  PasswordForgot: {
    heading: 'Forgot password',
    send: 'send'
  },
  PasswordPair: {
    label: 'Password',
    labelConfirm: 'Confirm password',
    passwordMin8Chars: 'Min. 8 chars',
    passwordNotMatching: 'Passwords not equal'
  },
  SelectCity: {
    label: 'City',
    loading: 'loading...',
    noData: 'No cities found',
    placeholder: 'Type zip or city name to search...'
  },
  Settings: {
    email: 'Change email',
    gdpr: 'GDPR',
    heading: 'Settings',
    password: 'Password',
    personalInfo: 'Personal Data'
  },
  AgentSettings: {
    heading: 'Agent settings',
    agentEdit: 'Personal',
    agentDisable: 'Disable'
  },
  SidebarBlock: {
    company: 'Company',
    dashboard: 'Overview',
    employees: 'Employees',
    help: 'Help',
    referrals: 'Referrals',
    settings: 'Settings',
    subscription: 'Subscription',
    timesheets: 'Times sheets',
    users: 'Users',
    customerCreate: 'New contract',
    agentContracts: 'Contract overview',
    agencies: 'Agency overview',
    agencySettings: 'Agency',
    agencyAgents: 'Agents',
    agencyContracts: 'Contracts',
    agencyStatements: 'Statements'
  },
  AgencyStatements: {
    heading: 'Statements overview'
  },
  AgencyContracts: {
    heading: 'Contracts overview'
  },
  AgencyAgents: {
    heading: 'Agents overview'
  },
  AgentEdit: {
    number: 'Number',
    firstName: 'First name',
    lastName: 'Last name',
    editAgent: 'Edit agent'
  },
  Subscription: {
    addressCity: 'City',
    addressCountry: 'Country',
    addressData: 'Adress',
    addressLine: 'Street',
    addressState: 'State',
    basicData: 'Basic',
    cardData: 'Credit card',
    email: 'Email',
    headline: 'Subscription',
    name: 'Name',
    update: 'Save'
  },
  ValidationRules: {
    isRequired: 'Required field',
    isValidPassword: 'Minimum 8 characters',
    isValidEmail: 'No valid email',
    isValidNumber: 'No number',
    isPasswordMatch: 'Passwords do not match',
    isPercent: 'Value between 0 and 100'
  },
  EmailSettings: {
    attention: 'A new email address wont be accepted until you verify it',
    edit: 'Save new email'
  },
  GdprSettings: {
    acceptGdpr: 'Accept agreement',
    body: 'On 25 May 2018, the new regulation on the processing of personal data by private companies and public bodies will come into force. If your registered office is within the EU or you have customers from the EU, you must conclude an order processing agreement with us by the deadline.',
    heading: 'General data protection policy',
    validGdpr: 'You have concluded a valid order processing agreement with us on {date} at {time} o\'clock.'
  },
  PasswordSettings: {
    edit: 'Save new password',
    labelConfirm: 'Confirm your old password'
  },
  PersonalInfoSettings: {
    edit: 'Save personal data',
    firstName: 'First name',
    lastName: 'Last name',
    selectLanguage: 'Select language'
  },
  DisabledUserButton: {
    pleaseSignUp: 'This is a demo version, please subscribe to use it'
  },
  Users: {
    heading: 'User overview',
    noInfoYet: 'Loading user data...',
    userEmail: 'Email',
    userId: 'ID'
  },
  UserCreateAdmin: {
    add: 'Create Admin',
    createAdmin: 'New Administrator',
    close: 'Cancel',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email'
  }
}
